import { api } from './api';

export interface Agency {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
}

export interface AgencyError {
  message: string[];
  error: string;
  statusCode: number;
}

export const agencies = {
  getAll: async (): Promise<Agency[]> => {
    try {
      const response = await api.get<Agency[]>('/agencies');
      return response;
    } catch (error) {
      const agencyError = error as AgencyError;
      throw agencyError;
    }
  },
};
